
import { useQuery } from "@tanstack/react-query";
import { fetchReagentRequests } from "@/services/reagentRequests";
import { useState, useMemo } from "react";
import { Category } from "@/types/reagent.types";
import { ReagentRequest } from "@/types/reagentRequest.types";

export const useReagentRequestsQuery = () => {
  const [isRetrying, setIsRetrying] = useState(false);
  
  const { 
    data: requests = [], 
    isLoading, 
    error, 
    isError,
    refetch 
  } = useQuery({
    queryKey: ["reagentRequests"],
    queryFn: fetchReagentRequests,
  });

  // Extract unique categories from all requests
  const categories = useMemo(() => {
    const categoriesMap = new Map<string, Category>();
    
    requests.forEach(request => {
      if (request.categories && request.category_id) {
        categoriesMap.set(request.category_id, request.categories);
      }
    });
    
    return Array.from(categoriesMap.values());
  }, [requests]);

  // Extract unique locations (universities) from all requests
  const locations = useMemo(() => {
    const locationsSet = new Set<string>();
    
    requests.forEach(request => {
      if (request.profiles?.university) {
        locationsSet.add(request.profiles.university);
      }
    });
    
    return Array.from(locationsSet);
  }, [requests]);
  
  const handleRefetch = async () => {
    setIsRetrying(true);
    await refetch();
    setIsRetrying(false);
  };

  return {
    requests,
    categories,
    locations,
    isLoading,
    error,
    isError,
    refetch: handleRefetch,
    isRetrying
  };
};
